export default __webpack_public_path__ + "static/media/January2023.9d160f58.png";